import { Link, Navigate, Route, Routes, useLocation } from "react-router-dom";
import React from "react";
import { useSelector } from "react-redux";
import Header from "../Header/Header";
import { commonService } from "../../utils/commonService";
import AsideRmCopilot from "./Components/AsideRmCopilot";
import Loader from "../Loader/Loader";
const RmCopilotDashboard = React.lazy(
  () => import("./Components/Dashboard/RmCopilotDashboard"),
);
const ConfigKPI = React.lazy(() => import("./Components/ConfigKPI/ConfigKPI"));
const RmCopilot = React.lazy(() => import("./Components/InsideRmCopilot/RmCopilot"));

function LayoutRmCopilot() {
  const token = commonService.getItem("token");
  const sidebarOpen = useSelector(
    (store) => store.headerProperty.isSidebarOpen,
  );
  const location = useLocation();
  const hideLayout = location.pathname === "/RmCopilot/rm-copilot";

  return (
    <div
      className={`mainRoot ${sidebarOpen ? "full-menu" : "icon-toggle-menu"}`}
    >
      {!hideLayout && <Header />}
      {!hideLayout && <AsideRmCopilot />}
      <main className={"revenue-management-page-body container-data-load"}>
        <Routes>
          <Route
            path="/rm-copilot-dashboard"
            element={
              token ? (
                <React.Suspense fallback={<Loader />}>
                  <RmCopilotDashboard />
                </React.Suspense>
              ) : (
                <Navigate to="/" replace />
              )
            }
          />
          <Route
            path="/rm-copilot"
            element={
              token ? (
                <React.Suspense fallback={<Loader />}>
                  <RmCopilot />
                </React.Suspense>
              ) : (
                <Navigate to="/" replace />
              )
            }
          />
          <Route
            path="/config-kpi/:id"
            element={
              token ? (
                <React.Suspense fallback={<Loader />}>
                  <ConfigKPI />
                </React.Suspense>
              ) : (
                <Navigate to="/" replace />
              )
            }
          />
        </Routes>
        {/* {!hideLayout && <MovableNova initialX={20} initialY={10} />} */}
      </main>
    </div>
  );
}

export default LayoutRmCopilot;
